import React, { useRef, useEffect, useState  } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalStory } from '../../../../redux/actions/partials/modals/modalStory';
import { IMAGE_ADDRESS } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 


const ModalStory = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, story } = useSelector(state => state.modalStory);


	const videoRef = useRef(null);
  	const [progress, setProgress] = useState(0);
  	const [time, setTime] = useState("00:00");

	const handleClose = () => {
		dispatch(handleChangeDataModalStory('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalStory('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalStory]);


  	// تبدیل ثانیه به mm:ss
  	const formatTime = (seconds) => {
	    if (isNaN(seconds)) return "00:00";
	    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
	    const s = Math.floor(seconds % 60).toString().padStart(2, "0");
	    return `${m}:${s}`;
  	};


  	useEffect(() => {
  		if (!isActive) return;

  		console.log('inja umad');
	    const video = videoRef.current;
	    if (!video) return;

	    console.log('arash video');
	    console.log(video);
	    console.log(video.currentTime);
	    console.log(video.duration);

	    const updateProgress = () => {
	      	const percent = (video.currentTime / video.duration) * 100;
	      	setProgress(percent);
	      	setTime(formatTime(video.currentTime));
	    };

	    video.addEventListener("timeupdate", updateProgress);
	    return () => {
	      	video.removeEventListener("timeupdate", updateProgress);
	    };
  	}, [isActive, story]);

  	if (!isActive || !story) return null;



	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };




    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.8)', zIndex: '11'}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open relative w-fit lg:px-20 mx-auto flex justify-center items-center flex-row" tabIndex="-1" role="dialog" aria-modal="true" >
				

				{ !isMobile &&
				<div className="my-auto p-2 rounded-circle border-complete absolute bottom-0 top-0 m-auto h-max bg-neutral-000 cursor-pointer styles_left__9JtiE">
					<div className="flex">
						<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
							<use xlinkHref="#chevronLeft" />
						</svg>
					</div>
				</div>
				}

				<div className="grow-0 lg:w-90 w-screen" style={{height: '576.65px'}}>
					<div className="w-full h-full flex flex-col">
						<div className="w-full h-30 relative flex-1">
							<div className="absolute top-0 left-0 right-0 h-20 z-1 styles_VideoModalContentHeaderOverlay__BR_XF" />
							<div className="absolute top-0 left-0 right-0 z-2 px-5 pt-4 flex justify-between items-center w-full">
								<div className="flex items-center">
									<div onClick={handleClose} className="flex cursor-pointer cursor-pointer">
										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
											<use xlinkHref="#arrowRight" />
										</svg>
									</div>
									{/*<a className="mr-5 flex items-center" href="/magnet/users/Shayan.nm">
										<div className="shrink-0" style={{width: '40px', height: '40px', lineHeight: 0}}>
											<img className="w-full rounded-circle inline-block" src="https://dkstatics-public.digikala.com/digikala-content-x-profile/40d03b5098ce0d478d26bb4c57a6bc1f5c12a2b1_1650892992.jpg?x-oss-process=image/resize,m_lfit,h_150,w_150/quality,q_80" width={40} height={40} alt="" title style={{objectFit: 'contain'}} />
										</div>
										<div className="mr-2">
											<p className="text-h5 text-neutral-100">Shayan.nm
											</p>
										</div>
									</a> */}
								</div>
								{/*<div>
									<div className="pointer-events-none">
										<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--small__4O6Vv styles_btn--white__6nwxQ rounded-medium whitespace-nowrap">
											<div className="flex items-center justify-center relative grow">دنبال کن
											</div>
										</button>
									</div>
								</div> */}
							</div>
							<div className="w-full h-full relative">
								<div className="flex items-center justify-center">
									<div className="flex items-center justify-around absolute inset-0 mx-auto my-auto z-[-1]" style={{width: '24px', height: '24px'}}>
										<div className="rounded-circle styles_Loading__circle1__K7HNJ" style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} />
										<div className="rounded-circle styles_Loading__circle2__jpl_q" style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} />
										<div className="rounded-circle styles_Loading__circle3__otcH4" style={{width: '6px', height: '6px', background: 'rgb(129, 133, 139)'}} />
									</div>
								</div>
								<div style={{width: '100%', height: '100%'}}>
									<video ref={videoRef} preload="auto" autoPlay loop disablePictureInPicture={true} playsInline webkit-playsinline="true" x5-playsinline="true" src={IMAGE_ADDRESS + story.video} style={{width: '100%', height: '100%'}} />
								</div>
							</div>
							<div className="flex flex-col px-5 absolute bottom-0 right-0 left-0 z-2">
								<div className="absolute inset-0 z-0 styles_VideoModalContentFooterOverlay__Dr7La" />
								<div className="z-1">
									<div className="flex items-end justify-between lg:gap-2 gap-4">
										<div className="relative h-full">
											<div className="relative">
												<h5 className="text-h5 text-neutral-100">{story.title}
												</h5>
												<div className="text-body-1 mb-1 text-neutral-100 ellipsis-2" />
												<p className="text-body-1 mb-1 absolute w-full text-neutral-100 styles_shadowPostCaption__S8Xv_" />
											</div>
										</div>
										<div className="flex gap-4 flex-col">
											{/*<div>
												<div className="pointer-events-none">
													<span className="cursor-pointer text-white flex flex-col items-center text-body-strong">
														<div className="flex">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
																<use xlinkHref="#favoriteOff" />
															</svg>
														</div>
														<div>
															<span className="text-body1-strong">۱۳۱
															</span>
														</div>
													</span>
												</div>
											</div>
											<span className="cursor-pointer text-white flex flex-col items-center text-body-strong">
												<div className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
														<use xlinkHref="#comment" />
													</svg>
												</div>
												<div>
													<span className="text-body1-strong">۲
													</span>
												</div>
											</span>*/}
										</div>
									</div>
									<div className="w-full pt-4 pb-3 flex items-center justify-between gap-1">
										{/*<div className="pr-1 pl-1 w-full">
											<div className="styles_noUi-target__XAwMt undefined styles_noUi-horizontal__dw6Te styles_noUi-txt-dir-rtl__iqVbf">
												<div className="styles_noUi-base__VsFI9">
													<div className="styles_noUi-connects__bbrsT">
														<div className=" styles_noUi-connect__FBBSb !bg-white" style={{transform: 'translate(0%, 0px) scale(0.54, 1)'}} />
													</div>
													<div className="styles_noUi-origin__UEgCh" style={{transform: 'translate(54%, 0px)', zIndex: 4}}>
														<div className="styles_noUi-handle__8L8O2 !bg-white !h-4 !w-4 undefined" data-handle={0} tabIndex={0} role="slider" aria-orientation="horizontal" aria-valuemin={0.0} aria-valuemax={100.0} aria-valuenow={54.0} aria-valuetext={54.00}>
															<div className="styles_noUi-touch-area__Lm7W6" />
														</div>
													</div>
												</div>
												<div className="styles_noUi-pips__UmpDJ hidden styles_noUi-pips-horizontal__KW2RI">
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '0%'}} />
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '20%'}} />
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '40%'}} />
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '60%'}} />
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '80%'}} />
													<div className="styles_noUi-marker__5cMCy styles_noUi-marker-horizontal__4RGRJ undefined" style={{left: '100%'}} />
												</div>
											</div>
										</div>*/}
										<div className="w-full h-1 bg-gray-600 rounded-full overflow-hidden ml-2" style={{direction: "ltr"}}>
								            <div 
								              	className="h-full bg-white transition-all duration-200" 
								              	style={{ width: `${progress}%` }}
								            />
							          	</div>
										<p className="text-white text-caption-strong w-12 text-left">{toPersianDigits(time)}
										</p>
									</div>
								</div>
							</div>
						</div>
						{/*<div className="shrink-0 grow-0 flex gap-2 overflow-x-auto overflow-y-auto hide-scrollbar bg-neutral-900 p-2">
							<div className="ml-2 lg:ml-0 select-none flex shrink-0 items-center rounded bg-neutral-000 w-[240px] p-0.5 cursor-pointer relative overflow-hidden">
								<div className="shrink-0 select-none" style={{width: '60px', height: '60px', lineHeight: 0}}>
									<img class="w-full rounded inline-block" src="https://dkstatics-public.digikala.com/digikala-products/0798069927fae6c81e64d128ad79fda60a94dae2_1749385872.jpg?x-oss-process=image/resize,m_lfit,h_115,w_115/quality,q_60" width="60" height="60" alt="" title="" style={{objectFit: 'contain'}} />
								</div>
								<span className="text-body2-strong ellipsis-2 px-2 pt-2 select-none">اسپیکر بلوتوثی انکر مدل SoundCore Select 3
								</span>
							</div>
						</div> */}
					</div>
				</div>

				{ !isMobile &&
				<div className="my-auto p-2 rounded-circle border-complete absolute bottom-0 top-0 m-auto h-max bg-neutral-000 cursor-pointer styles_right__bWd56">
					<div className="flex">
						<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
							<use xlinkHref="#chevronRight" />
						</svg>
					</div>
				</div>
				}


			</div>
		</div>



        
    );
}

export default ModalStory;
